import theme from '../../../lib/theme';
import {hexToRGB, lightness} from '../../../lib/colourUtilities';
import { NavbarProps } from './Navbar';

const {
  scale,
  layers,
  layouts,
  corners,
  colors,
  media,
  animations,
  font: { families, heights, spacings, ...font },
} = theme;

export default ({ brand = 'travel360' }: NavbarProps) => {
  return {
    accountOpen: {
      display: 'block',
    },
    accountDropdown: {
      fontWeight: 400,
      fontSize: '1rem',
    },
    avatar: {
      height: '47px',
      minWidth: '47px',
      backgroundColor: '#20ffc0',
      color: '#651fff',
      borderRadius: '23.5px',
      textAlign: 'center',
      padding: '0.5rem',
      marginRight: '10px',
    },
    navMemberDealsText: {
      [media.s.down]: {
        display: `none`,
      },
    },

    mainMenu2: {
      flexDirection: 'row',

      [media.l.down]: {
        flexDirection: 'column',
      },
    },

    navbarToggler: {
      border: '0!important',
      backgroundColor: colors.sas.primary,
    },

    '.dropdown': {
      position: 'relative',
    },

    dropdownMenu: {
      /* ul */
      backgroundColor: colors.sas.primary,
      borderRadius: 0,
      top: `calc(100% - 3px)`,
      margin: '0',
      padding: '0',
      border: 'none',
      left: '0',

      ' > li > a': {
        fontWeight: '400',
        color: `${colors.white}!important`,
        fontSize: `16px!important`,
        backgroundColor: `transparent`,
      },
    },
    
    navLink: {
      color: colors.sas.secondary,

      '&:hover': {
        color: colors.white,
      },

      ' + ul.dropdown-menu': {

        ' > li > a': {

          '&:hover': {
            backgroundColor: lightness(colors.sas.primary_dark, -20),
          },
        },
      },
    },
    '.dropdown-menu.show': {
      display: 'block',
    },

    sasPageHeader: {
      fontFamily: families.primary,
    },

    topNavigationBar: {
      backgroundColor: `${brand != 'over60hols' ? colors.black : colors.white} !important`,
      display: 'flex',
      justifyContent: 'center !important',
      alignItems: 'flex-end !important',
      margin: '0 auto !important',
      padding: '0 !important',

      'li.nav-item': {
        'a.nav-link': {
          color: `${colors.white} !important`,

          '&.showAsButton': {
            backgroundColor: `${colors[brand].primary_dark} !important`,
            borderRadius: '20px',
            fontSize: `${font.s} !important`,
            padding: '4px 1rem !important',
            display: 'flex',
            alignItems: 'center',
            textWrap: 'nowrap',

            [media.m.down]: {
              padding: '4px 0.5rem !important',
            },
            
            '&.inverted': {
              backgroundColor: `${colors[brand].secondary} !important`,
              color: `${colors.black} !important`,
            },
          },
        },

        '&.active': {
          'a.nav-link': {
            backgroundColor: colors.white,
            borderRadius: `${corners.s} ${corners.s} 0 0`,
          },
        },
      },
    },

    navbarTopNav: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '1rem !important',
    },

    navLogos: {
      padding: `${brand != 'over60hols' ? spacings.m : 0} 0 0 0}`,
      minWidth: `calc(100% / 3)`,
      flex: `1 0 calc(100% / 3)`,
      justifyContent: 'flex-end',
      flexGrow: 0,

      [media.l.down]: {
        order: `${brand != 'over60hols' ? '3' : '0'}`,
        minWidth: `${brand != 'over60hols' ? '80%' : 'calc(100% / 3)'}`,
        flexBasis: `${brand != 'over60hols' ? '1 0 80%' : '1 0 calc(100% / 3)'}`,
        justifyContent: `${brand != 'over60hols' ? 'flex-start' : 'flex-end'}`,
        paddingLeft: '1rem',
      },

      [media.m.down]: {
        order: `${brand != 'over60hols' ? '3' : '0'}`,
        minWidth: `${brand != 'over60hols' ? '75%' : 'calc(100% / 2)'}`,
        flexBasis: `${brand != 'over60hols' ? '1 0 75%' : '1 0 calc(100% / 2)'}`,
        paddingLeft: 'auto',
      },
    },

    navContact: {
      maxWidth: `calc(100% / 3)`,
      flex: `0 1 calc(100% / 3)`,
      justifyContent: `center`,
      alignItems: 'center',
      alignSelf: 'center',
      gap: '1rem',
      order: brand == 'over60hols' ? 3 : 1,

      [media.l.down]: {
        order: 1,
        maxWidth: `${brand != 'over60hols' ? '60%' : 'calc(100% / 3)'}`,
        flex: `${brand != 'over60hols' ? '0 0 60%' : '0 1 calc(100% / 3)'}`,
        justifyContent: `center`,
      },

      [media.m.down]: {
        order: 1,
        maxWidth: 'unset',
        justifyContent: `center`,
        flex: `0 0 ${brand == 'travel360' ? '70%' : brand == 'over60hols' ? '50%' : '60%'}`,
        gap: '5px',
      },
    },

    navSocials: {
      flex: `0 1 calc(100% / 5)`,
      justifyContent: 'flex-start',
      alignItems: 'center',
      gap: '1rem',
      paddingLeft: '1rem !important',
      order: 2,

      [media.l.down]: {
        order: 2,
        minWidth: `unset`,
        flex: `1 0 20%`,
        justifyContent: `${brand == 'over60hols' ? 'flex-start' : 'center'}`,
      },

      [media.m.down]: {
        flex: `0 0 ${brand == 'travel360' ? '30%' : '40%'}`,
        gap: 0,
      },
    },

    navMain: {
      justifyContent: 'center !important',
      alignItems: 'center',
      gap: '0.5rem',
      display: 'flex',
      flexDirection: 'row',
      flexGrow: '1',
      backgroundColor: brand != 'over60hols' ? colors.white : 'transparent',
      order: brand == 'over60hols' ? 2 : 3,
      alignSelf: brand == 'over60hols' ? 'center' : 'auto',

      [media.l.down]: {
        display: `${brand != 'over60hols' ? 'none !important' : 'flex'}`,
        order: brand == 'over60hols' ? 2 : 3,
      },

      [media.xl.up]: {
        gap: '1rem',
      },

      'li.nav-item': {
        'a.nav-link': {
          color: `${colors.black} !important`,
          fontSize: `${font.s}`,

          [media.xl.up]: {
            gap: '1rem',
            fontSize: `${font.m}`,
          },
        },
      },

      '> ul': {
        listStyle: 'none',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '3rem',
        margin: '0',
        flex: '0 0 80%',

        [media.xl.down]: {
          flex: '0 0 100%',
          gap: '1.75rem',
        },

        [media.l.down]: {
          gap: '3rem',
        },

        '> li.nav-item': {
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',

          '> a.nav-link': {
            paddingTop: `calc(0.5rem + 5px)`,
          },

          '&.active > a.nav-link': {
            borderBottom: `2px solid ${colors.sas.primary}`,
          },

          '&.dropdown': {
            position: 'static',

            '> a.nav-link.dropdown-toggle': {
              cursor: 'pointer',
            },

            '> ul.dropdown-menu.show': {
              position: 'absolute',
              width: '100vw',
              left: '0',
              right: '0',
              display: 'flex !important',
              justifyContent: brand === 'sas' ? 'center' : 'space-evenly',
              alignItems: 'flex-start',
              maxHeight: '50vh',
              overflowY: 'auto',
              zIndex: '10',
              gap: brand === 'sas' ? '1rem' : '2rem',
              marginTop: '0',
              flexWrap: brand === 'sas' ? 'wrap' : 'nowrap',

              [media.xl.up]: {
                width: '80vw',
                left: '10vw',
                right: '10vw',
                maxHeight: '50vh',
              },

              li: {},
            },
          },
        },
      },
    },

    navSearch: {
      backgroundColor: `${colors.white} !important`,
      order: 4,
      justifyContent: 'center',

      'li.nav-item': {
        'a.nav-link, a.nav-link *': {
          color: `${colors.black} !important`,
        },
      },

      [media.l.up]: {
        display: 'none !important',
      },

      [media.l.down]: {
        backgroundColor: `${colors.black} !important`,
        order: 4,
        flex: `0 1 auto`,

        'li.nav-item': {
          'a.nav-link, a.nav-link *': {
            color: `${colors.white} !important`,
          },
        },
      },
      //  always hide search on over60hols
      display: `${brand == 'over60hols' ? 'none !important' : 'flex'}`,
    },

    navToggler: {
      backgroundColor: colors.black,
      order: 5,
      flex: `0 1 10%`,
      justifyContent: 'center',
      borderColor: 'transparent !important',

      [media.l.up]: {
        display: 'none !important',
      },

      //  always hide mobile menu on over60hols
      display: `${brand == 'over60hols' ? 'none !important' : 'flex'}`,
    },

    styleTray: {
      position: 'fixed',
      top: '0',
      left: '100%',
      width: '100%',
      height: '100%',
      zIndex: layers.highest,
      display: 'none',

      '&.show': {
        display: 'flex !important',
        left: '0',
        animation: `500ms ${animations.slideInReverse} linear`,
      },
    },

    navbarCollapse: {
      display: 'none',
      width: '100%',
      right: '100vw',
      alignItems: 'flex-start !important',
      justifyContent: 'flex-end',
      // position: 'absolute',
      top: '0',

      '&.show': {
        zIndex: layers.highest,
        width: '500px',
        right: '0',
        padding: '0',
        display: 'flex !important',

        [media.m.down]: {
          width: '60%',
        },

        [media.m.down]: {
          width: '100%',
        },

        '> ul, > i': {
          zIndex: layers.highest,
        },

        '&:before': brand !== 'sas' ? {
          content: '""',
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          backgroundColor: hexToRGB(colors.black, '0.8'),
          zIndex: layers.high,
        } : {},
      },

      '> i': {
        flex: `0 0 40px`,
        display: `flex`,
        justifyContent: `center`,
      },
    },

    navbarMobile: {
      display: 'flex',
      width: '100%',
      justifyContent: 'flex-end',

      [media.l.up]: {
        display: brand === 'sas' ? 'flex!important' : 'none !important',
      },
    },

    navMobile: {
      listStyle: 'none',
      flex: `0 0 calc(100% - 40px)`,
      height: `100%`,
      backgroundColor: '#f8f8f8',
      padding: `0`,
      overflowY: 'auto',

      '> li.nav-item': {
        backgroundColor: colors.white,
        width: '100%',
        padding: `0`,

        '> ul': {
          listStyle: 'none',
          padding: '0',

          '> li': {
            padding: `0.65rem 0 !important`,
            borderBottom: `1px solid ${colors.grey}`,

            '> a': {
              color: colors.black,
              fontWeight: '500',
              padding: `0 0 0 1rem`,
              cursor: 'pointer',

              '&:hover': {
                color: colors[brand].primary,
                textDecoration: 'none !important',
              },
              '&:focus, &:selected': {
                backgroundColor: colors.grey,
                color: colors[brand].primary,
                textDecoration: 'none !important',
              },
            },
          },
        },
      },
    },

    mobileBreadcrumb: {
      borderBottom: `2px solid ${colors.grey}`,

      '> a': {
        display: 'flex !important',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '0.5rem',
        width: `100%`,
        fontWeight: 700,
        color: colors.black,
        cursor: 'pointer',
      },
    },

    dropdown: {
      display: 'flex',
      position: 'relative',
      flexDirection: 'column',

      'a.dropdown-toggle': {
        color: colors.sas.primary,
        fontSize: `${font.s} !important`,
        fontWeight: '700',
        cursor: 'hand',

        '&:hover': {
          backgroundColor: 'transparent',
        },

        '&:after': {
          display: 'none',
        },

        '+ .dropdown-menu': {
          display: 'flex',
          position: 'static !important',
          border: 'none !important',
          flexDirection: 'column',
          paddingTop: 0,
          paddingBottom: '1rem',
        },
      },
    },

    dropdownItem: {
      fontSize: `${font.s} !important`,
      fontWeight: '700',

      '&:hover': {
        backgroundColor: 'transparent',
      },
    },

    brandLogo: {
      height: `${brand != 'over60hols' ? '20px' : 'auto'}`,
      width: `${brand == 'over60hols' ? '200px' : 'auto'}`,

      [media.m.down]: {
        height: `${brand == 'over60hols' ? 'auto' : '15px'}`,
        width: `${brand == 'over60hols' ? '100%' : 'auto'}`,
      },
    },
  };
};
